import { Method } from 'axios';
import { Executable } from '../executable';
import { BambuProgram, BambuProgramInput, ProgramStatusCode } from '../interfaces';

/**
 * The UpdateProgramInput used by the constructor of UpdateProgram
 */
export class UpdateProgram extends Executable<BambuProgram> implements Partial<BambuProgramInput> {
  public programId?: number;

  public name?: string;

  public abbreviation?: string;

  public brandId?: number;

  public tenantId?: number;

  public templateId?: number;

  public logo?: string;

  public color?: string;

  public statusCode?: ProgramStatusCode;

  public imageFile?: string | Buffer;

  public getMethod(): Method {
    return 'patch';
  }

  public getResponse(apiResponse: any): BambuProgram {
    return apiResponse;
  }

  public getURLPath(tenantId?: string): string {
    if (!this.brandId) throw new Error('brandId is required');
    if (!this.programId) throw new Error('programId is required');
    return `/${this.brandId}/programs/${this.programId}`;
  }

  constructor(
    input?: Partial<BambuProgramInput> & { tenantId: number; brandId: number; name: string }
  ) {
    super();
    if (input) {
      Object.assign(this, input);
    }
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): Partial<BambuProgramInput> & { tenantId: number; name: string } {
    if (!this.tenantId) throw new Error('tenantId is required');
    if (!this.name) throw new Error('name is required');
    return {
      tenantId: this.tenantId,
      name: this.name,
      abbreviation: this.abbreviation,
      templateId: this.templateId,
      logo: this.logo,
      color: this.color,
      statusCode: this.statusCode,
      imageFile: this.imageFile,
    };
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return 'brands';
  }
}
